import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import { Fragment } from 'react/cjs/react.production.min';
// import Home from './pages/home';
import {BrowserRouter as Router,Route,Switch} from "react-router-dom"
import Index from './pages';

function App() {
  return (
    <div>
      <Fragment>
          <Router>
            <Switch>
              <Route path="/" exact component={Index}/>
            </Switch>
          </Router>
      </Fragment>
    </div>
  )
}

export default App;
